import {
    setCustomFieldsSchemaQuery,
    useCustomFieldsSchemaQuery,
} from '../../lib/Queries';
import Loading from '../Loading';
import Select from '../Select';
import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import SingleFieldSchema from './SingleFieldSchema.jsx';
import SingleField from './SingleField.jsx';
import { useDebounce } from '@uidotdev/usehooks';
import { DocumentTextIcon } from '@heroicons/react/24/outline/index.js';
import SectionHeading from '../SectionHeading.jsx';

const CustomFields = ({
    fields,
    type,
    id,
    className,
    headerClassName,
    onChanged,
    alwaysEdit,
    excludeFields,
    hideTooltip,
}) => {
    const { save, isSaving } = useBusinessPostApi(
        `/custom-fields/${type}/${id}`,
    );
    const { data, isLoading } = useCustomFieldsSchemaQuery(type);

    const [localFields, setLocalFields] = useState(fields);
    const debouncedLocalFields = useDebounce(localFields, 500);
    const schema = (data || []).filter(
        item => !excludeFields || excludeFields.indexOf(item.key) < 0,
    );

    useEffect(() => {
        //if (JSON.stringify(fields) !== JSON.stringify(localFields)) {
        setLocalFields(fields);
        //}
    }, [id, JSON.stringify(fields)]);

    useEffect(() => {
        if (JSON.stringify(localFields) !== JSON.stringify(fields)) {
            // Changed! Send it up
            save({
                fields: localFields,
            }).then(() => {
                // Success? Need to do anything?
                if (typeof onChanged === 'function') {
                    onChanged();
                }
            });
        }
    }, [JSON.stringify(debouncedLocalFields)]);

    if (isLoading) {
        return <Loading />;
    }

    if (typeof schema.map !== 'function') {
        return null;
    }

    return (
        <div className={className}>
            {schema.map((item, idx) => (
                <SingleField
                    key={item.key}
                    hideTooltip={hideTooltip}
                    schema={item.schema}
                    value={localFields ? localFields[item.key] : ''}
                    onChange={newValue =>
                        setLocalFields(old => ({
                            ...old,
                            [item.key]: newValue,
                        }))
                    }
                    className={idx < schema.length - 1 ? 'mb-4' : ''}
                    alwaysEdit={alwaysEdit}
                />
            ))}
        </div>
    );
};

export default CustomFields;
